import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import NavBar from "./components/NavBar";
import Home from "./pages/Home";
import Leon from "./pages/Leon";
import Tram from "./pages/Tram";
import Transactions from "./pages/TransactionPage"

function App() {
  return (
    <Router>
      <NavBar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/leon" element={<Leon />} />
          <Route exact path="/tram" element={<Tram />} />
          <Route exact path="/transactions" element={<Transactions />} />
        </Routes>
    </Router>
  );
}



export default App;
